import ID from './ID'
import InitiativeType from './InitiativeType'

export default class InitiativeChannel {
  constructor(
    public id: ID = new ID(),
    public creatorId: ID = new ID(),
    public planId: ID = new ID(),
    public name: string = '',
    public description: string = '',
    public initiativeTypes: InitiativeType[] = [],
    public isNested: boolean = false,
    public isLead: boolean = false,

    public abbreviatedPlanName: string = '', //Populated on front-end
  ) {}

  public get key() {
    return 'initiative-channel-' + this.id.intID.toString()
  }

  public get hasInitiatives(): boolean {
    let returnValue = false
    if (this.initiativeTypes.length) {
      this.initiativeTypes.forEach((type) => {
        if (type.hasInitiatives) {
          returnValue = true
        }
      })
    }
    return returnValue
  }

  public get sortedInitiativeTypes(): InitiativeType[] {
    return [...this.initiativeTypes].sort((a,b) => a.orderIndex - b.orderIndex)
  }

  public static fromResponseObject(obj): InitiativeChannel {
    if (!obj) return new InitiativeChannel()
    if (!obj.initiativeTypes) return new InitiativeChannel(ID.fromResponseObject(obj.id, 'initiative_channels'))

    const initiativeTypes = [] as InitiativeType[]
    obj.initiativeTypes.forEach((element) => {
      initiativeTypes.push(InitiativeType.fromResponseObject(element))
    })

    let planId = new ID()
    if(obj.planId && obj.planId.id){
      planId = obj.planId
    }else if(obj.plan){
      if(typeof obj.plan === 'string'){
        planId = ID.fromResponseObject(obj.plan, 'plans')
      }
    }

    return new InitiativeChannel(
      ID.fromResponseObject(obj.id, 'initiative_channels'),
      ID.fromResponseObject(obj.creator, 'users'),
      planId,
      obj.name,
      obj.description,
      initiativeTypes,
      obj.isNested ? obj.isNested : false,
      obj.isLead ? obj.isLead : false,
    )
  }

  public forRequestObject() {
    return {
      id: this.id.intID == 0 ? null : this.id.apiID,
      creator: this.creatorId.intID == 0 ? null : this.creatorId.apiID,
      plan: this.planId.intID == 0 ? null : this.planId.apiID,
      name: this.name,
      description: this.description,
      initiativeTypes: this.initiativeTypes.map((type) => {
        return type.id.apiID
      }),
    }
  }
}
